import Swiper from "swiper/bundle";

export default function companyGroupsSwiper (){
    let swiperContainer = document.querySelector('[data-company-groups="swiper"]');

    if(swiperContainer){
        let swiper = new Swiper(swiperContainer, {
            modules: [],
            loop: false,
            slidesPerView: 1,
            spaceBetween: 8,
            breakpoints: {
                992:{
                    speed: 0,
                    allowTouchMove:false,
                }
            }
        });

        let paginationButtons = swiperContainer.querySelectorAll('[data-company-groups-index]');
        paginationButtons.forEach(button => {
            button.addEventListener('mouseover', (event) => {
                paginationButtons.forEach(btn => btn.classList.remove('active'));
                button.classList.add('active');
                swiper.slideTo(button.dataset.companyGroupsIndex);
            });
        });
    }

    let splineViewer = document.querySelectorAll('spline-viewer');

    splineViewer.forEach(item => {
        let shadowRoot = item.shadowRoot;
        let logo = shadowRoot.querySelector('#logo');
        console.log(logo);
        logo.style.visibility = 'hidden';
    })
}